import slugify from 'slugify';

const API_SAFE_SLUGIFY_OPTIONS = {
	replacement: '-',
	lower: false,
	trim: false,
} as const;

export function toApiSafeValue(value?: string): string | undefined {
	if (value === undefined) return value;

	return slugify(value, API_SAFE_SLUGIFY_OPTIONS)
		.replaceAll(/[^\w-]+/g, '')
		.replaceAll(/^-+/g, '');
}

/**
 * Lowercased {@link toApiSafeValue}, for values that land in a URL.
 *
 * Cases with `toLowerCase`, never `toLocaleLowerCase`: the latter follows the runtime locale, and
 * Turkish maps `I` to the dotless `ı` (U+0131) — a non-ASCII character the api-safe filter has
 * already run past by this point.
 */
export function toApiSafeSlug(value?: string): string | undefined {
	return toApiSafeValue(value)?.toLowerCase();
}
